import { Award, Target, Wallet, Flame, Trophy, Gem, BadgeCheck, Lock } from 'lucide-react';

const ICONS = {
  first_trade: Target,
  first_deposit: Wallet,
  ten_trades: Flame,
  five_wins: Trophy,
  volume_10k: Gem,
  metal_trader: Award,
  kyc_verified: BadgeCheck,
};

const progressLabel = (a) =>
  a.key === 'volume_10k' ? `$${Math.round(a.progress).toLocaleString()} / $${a.goal.toLocaleString()}` : `${a.progress} / ${a.goal}`;

export const AchievementsCard = ({ achievements }) => (
  <div className="glow-card p-6 rounded-xl" data-testid="profile-achievements-card">
    <div className="flex items-center gap-3 mb-6">
      <Award className="h-6 w-6 text-amber-400" />
      <h3 className="text-xl font-bold">Achievements</h3>
    </div>
    <div className="space-y-3">
      {achievements.map((a) => {
        const Icon = a.unlocked ? ICONS[a.key] || Award : Lock;
        const pct = Math.min(100, (a.progress / a.goal) * 100);
        return (
          <div
            key={a.key}
            data-testid={`profile-achievement-${a.key}`}
            data-unlocked={a.unlocked}
            className={`p-3 rounded-lg border ${a.unlocked ? 'bg-gradient-to-r from-purple-500/15 to-teal-500/10 border-purple-500/30' : 'bg-gray-900/30 border-gray-700/40'}`}
          >
            <div className="flex items-start gap-3">
              <div className={`p-2 rounded-lg ${a.unlocked ? 'bg-amber-500/15 text-amber-300' : 'bg-gray-800 text-gray-500'}`}>
                <Icon className="h-4 w-4" />
              </div>
              <div className="flex-1 min-w-0">
                <p className={`font-bold text-sm ${a.unlocked ? '' : 'text-gray-400'}`}>{a.title}</p>
                <p className="text-xs text-gray-400">{a.description}</p>
                {!a.unlocked && a.goal > 1 && (
                  <div className="mt-2">
                    <div className="h-1.5 bg-gray-800 rounded-full overflow-hidden">
                      <div className="h-full bg-purple-500 rounded-full" style={{ width: `${pct}%` }} />
                    </div>
                    <p className="text-[10px] text-gray-500 mt-1">{progressLabel(a)}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

export default AchievementsCard;
